import { usePlanOnlyUseCreditPayment as useOnlyUseCreditPayment } from "@/components/features/items/edit/plan/_shared/ui/components/plan-attributes/only-use-credit-payment/hooks";

import { useProductDayTripPlanFormModelContext } from "../../../../context";

export const useDayTripPlanOnlyUseCreditPayment = () => {
	const { viewModel, onSetViewModel } = useProductDayTripPlanFormModelContext();
	const { onlyUseCreditPayment } = viewModel;

	return useOnlyUseCreditPayment({ onSetViewModel, onlyUseCreditPayment });
};
